.container {
  background-color: var(--pgm-sys-color-surface-container-lowest);
  border: 1px solid var(--pgm-sys-color-outline-variant);
  border-radius: 12px;
  box-sizing: border-box;
  color: var(--pgm-sys-color-on-surface);
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.table {
  border-collapse: collapse;
  min-width: 100%;
  width: 100%;
}

.headerCell {
  border-bottom: 1px solid var(--pgm-sys-color-outline-variant);
  color: var(--pgm-sys-color-on-surface-variant);
  height: 56px;
  padding: 0 var(--pgm-sys-spacing-4);
  white-space: nowrap;
}

.row {
  position: relative;
}

.row + .row .cell {
  border-top: 1px solid var(--pgm-sys-color-outline-variant);
}

.row:last-child .cell:first-child {
  border-bottom-left-radius: 11px;
}

.row:last-child .cell:last-child {
  border-bottom-right-radius: 11px;
}

.row:hover .cell {
  background-color: var(--pgm-sys-color-surface-container-low);
}

.cell {
  color: var(--pgm-sys-color-on-surface);
  height: 52px;
  padding: var(--pgm-sys-spacing-2) var(--pgm-sys-spacing-4);
  vertical-align: middle;
}

.alignStart {
  text-align: left;
}

.alignCenter {
  text-align: center;
}

.alignEnd {
  text-align: right;
}

.skeleton {
  animation: pulse 1.4s ease-in-out infinite;
  background-color: var(--pgm-sys-color-surface-container-high);
  border-radius: 4px;
  display: block;
  height: 12px;
  width: 80%;
}

.skeletonShort {
  width: 50%;
}

@keyframes pulse {
  50% {
    opacity: 0.5;
  }
}

.compactList {
  display: none;
  list-style: none;
  margin: 0;
  padding: 0;
}

.compactItem {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-2);
  padding: var(--pgm-sys-spacing-4);
}

.compactItem + .compactItem {
  border-top: 1px solid var(--pgm-sys-color-outline-variant);
}

.empty {
  border-top: 1px solid var(--pgm-sys-color-outline-variant);
  padding: var(--pgm-sys-spacing-10) var(--pgm-sys-spacing-6);
}







.visuallyHidden {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}

@media (max-width: 839.98px) {
  .hideOnCompact {
    display: none;
  }

  .compactList {
    display: block;
  }
}
